import React from "react";
import { useState, useEffect } from "react";
import AuthContext from "../../../../context/Auth";
import "./service.css";

const Services = (props) => {
  const { user } = React.useContext(AuthContext);
  const [visibleServices, setVisibleServices] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [msg, setMsg] = useState("");
  const [quantities, setQuantities] = useState({});
  const [addedServices, setAddedServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    setVisibleServices(5);
    const initialQuantities = {};
    props?.serviceData?.forEach(service => {
      initialQuantities[service.id] = 1;
    });
    setQuantities(initialQuantities);

    return () => clearTimeout(timer);
  }, [props?.serviceData]);

  useEffect(() => {
    if (isExpanded) {
      setVisibleServices(props?.serviceData?.length);
    } else {
      setVisibleServices(5);
    }
  }, [isExpanded]);

  const toggleScroll = () => {
    if (isExpanded) {
      window.scrollTo({
        top: document.getElementById("salon-services").offsetTop,
      });
    }
    setIsExpanded(!isExpanded);
  };

  const isServiceAdded = (serviceId) => {
    return props.selectedServices?.some(service => service.id === serviceId);
  };

  const getServiceQuantity = (serviceId) => {
    const service = props.selectedServices?.find(s => s.id === serviceId);
    return service?.quantity || 1;
  };

  const handleAddService = (item) => {
    if (props.onBookService) {
      props.onBookService(item, 1, 'add');
      if (window.innerWidth <= 768) {
        setTimeout(() => {
          const element = document.getElementById(`service-${item.id}`);
          if (element) element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }
  };

  const handleQuantityChange = (serviceId, change) => {
    const service = props.serviceData.find(s => s.id === serviceId);
    if (!service) return;

    const currentQuantity = getServiceQuantity(serviceId);
    const newQuantity = currentQuantity + change;

    if (newQuantity < 1) {
      props.onBookService(service, 0, 'remove');
    } else {
      props.onBookService(service, newQuantity, 'update');
    }

    if (window.innerWidth <= 768 && 'vibrate' in navigator) {
      navigator.vibrate(10);
    }
  };

  const { location } = React.useContext(AuthContext);

  const handleBookNowBtn = (item) => {
    handleAddService(item);

    if (!props.onBookService && props.salon?.name) {
      const quantity = quantities[item.id] || 1;
      let message = `I want to book ${quantity} ${quantity > 1 ? 'units of' : ''} the ${item?.service_name} available at ${props.salon?.name} in ${props.salon?.area}, ${props.salon?.city}.`;

      if (item?.discount) {
        message += `\n\nAs it is mentioned, it comes with discounted price of ₹${item.price} and takes ${formateTime(item?.service_time)} to complete the service.`;
      } else {
        message += `\n\nAs it is mentioned, it comes with price of ₹${item.price} and takes ${formateTime(item?.service_time)} to complete the service.`;
      }

      message += `\n\nPlease book it for me.`;
      setMsg(message);

      let link = `https://api.whatsapp.com/send?phone=916355167304&text=${encodeURIComponent(message)}`;
      window.open(link, "_blank");
    }
  };

  const log_adder = async (name) => {
    const requestBody = {
      category: "salon",
      name: name,
      location,
    };

    if (user != null) {
      requestBody.salon_user = user?.user_id || null;
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    };

    try {
      const response = await fetch(
        "https://trakky.in:8000/salons/log-entry/",
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Failed to log entry");
      }

      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error("Error logging entry:", error.message);
    }
  };

  const formateTime = (time) => {
    let str = "";

    if (time?.days) {
      str += time.days + " Days, ";
    }
    if (time?.seating) {
      str += time.seating + " Seating, ";
    }
    if (time?.hours) {
      str += time.hours + " Hours, ";
    }
    if (time?.minutes) {
      str += time.minutes + " Minutes, ";
    }

    str = str.slice(0, -2);

    return str;
  };

  useEffect(() => {
    setIsExpanded(false);
  }, [props?.serviceData]);

  // Skeleton Loading Component
  const ServiceSkeleton = () => {
    return (
      <div className="N-Service-main-container">
        {[...Array(5)].map((_, index) => (
          <div className="N-Main-Service-Item skeleton-item" key={index}>
            <div className="N-Service-Image-Div">
              <div className="N-Service-Image-container skeleton-image"></div>
              <div className="skeleton-button"></div>
            </div>
            <div className="N-Service-Content-Div">
              <div className="N-Service-Title-Div skeleton-text" style={{ width: '70%' }}></div>
              <div className="N-Service-Description-Div">
                <div className="skeleton-text" style={{ width: '90%' }}></div>
                <div className="skeleton-text" style={{ width: '80%' }}></div>
                <div className="skeleton-text" style={{ width: '60%' }}></div>
              </div>
              <div className="N-Service-price-book-Div">
                <div className="N-Service-pricing-Div">
                  <span className="skeleton-text" style={{ width: '50px' }}></span>
                  <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>●</span>
                  <span className="skeleton-text" style={{ width: '80px' }}></span>
                </div>
              </div>
              <div className="skeleton-text" style={{ width: '100px', marginTop: '10px' }}></div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="N-service-main-outer-container" id="salon-services">
      {isLoading ? (
        <ServiceSkeleton />
      ) : props?.serviceData?.length > 0 ? (
        <div className={`w-[100%]`}>
          <div className="N-Service-main-container">
            {props?.serviceData
              ?.slice(0, visibleServices)
              .map((item, index) => {
                const isAdded = isServiceAdded(item.id);
                const quantity = getServiceQuantity(item.id);
                return (
                  <div
                    className="N-Main-Service-Item"
                    key={item.id || index}
                    id={`service-${item.id}`}
                    data-service-cateogry={item?.categories}
                  >
                    <div className="N-Service-Image-Div">
                      <div className="N-Service-Image-container">
                        {item?.service_image && (
                          <img src={item.service_image} alt="not found" />
                        )}
                      </div>
                      {!isAdded ? (
                        <button
                          className="N-Service-call-now-btn-md bg-white text-black"
                          onClick={() => handleBookNowBtn(item)}
                        >
                          Book Now
                        </button>
                      ) : (
                        <div className="quantity-selector flex items-center bg-gradient-to-r from-[#AE86D0] to-[#512DC8] rounded-lg">
                          <button
                            className="quantity-btn minus text-white px-3 py-1"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleQuantityChange(item.id, -1);
                            }}
                            onTouchEnd={(e) => {
                              e.preventDefault();
                              handleQuantityChange(item.id, -1);
                            }}
                          >
                            -
                          </button>
                          <span className="text-white px-2">{quantity}</span>
                          <button
                            className="quantity-btn plus text-white px-3 py-1"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleQuantityChange(item.id, 1);
                            }}
                            onTouchEnd={(e) => {
                              e.preventDefault();
                              handleQuantityChange(item.id, 1);
                            }}
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="N-Service-Content-Div">
                      <div className="N-Service-Title-Div">
                        {item?.service_name}
                      </div>
                      <div className="N-Service-Description-Div">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item?.description,
                          }}
                        />
                      </div>
                      <div className="N-Service-price-book-Div">
                        <div className="N-Service-pricing-Div">
                          {item?.discount > 0 ? (
                            <>
                              <span className="N-s-p-d-actual-p">
                                ₹{item?.price}
                              </span>
                              <span className=" pl-[6px] text-gray-500 flex">
                                ₹
                                <del>
                                  <span>{item?.discount}</span>
                                </del>
                              </span>
                            </>
                          ) : (
                            <span className="N-s-p-d-actual-p">
                              ₹{item?.price}
                            </span>
                          )}
                          <span
                            style={{
                              paddingLeft: "5px",
                              paddingRight: "5px",
                            }}
                          >
                            ●
                          </span>
                          <span
                            style={{
                              color: " #646464",
                            }}
                          >
                            {formateTime(item?.service_time)}
                          </span>
                        </div>
                      </div>
                      {item?.service_details &&
                        <div className=" text-[#512dc8] font-medium text-sm cursor-pointer"
                          onClick={() => {
                            props?.handleServiceDetailsOpen(item.id);
                          }}
                        >
                          View details
                        </div>}
                    </div>
                  </div>
                );
              })}
          </div>

          {(props?.serviceData.length > visibleServices || isExpanded) && (
            <div className="N-view-more-button-container">
              <button onClick={toggleScroll}>
                {isExpanded ? "View Less" : "See all Services"}
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="N-service-no-data">
          <h2 className="text-[20px] font-medium h-[100px] w-full flex justify-center items-center">
            We will add menu soon!
          </h2>
        </div>
      )}
    </div>
  );
};

export default Services;